import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AnalyticsModule } from '@flyfreely-portal-ui/analytics';
import { EnhancedHelpModule } from '@flyfreely-portal-ui/enhanced-help';
import { SharedUiModule } from '@flyfreely-portal-ui/ui';
import { ValidationModule } from '@flyfreely-portal-ui/validation';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormlyBootstrapModule } from '@ngx-formly/bootstrap';
import { FormlyModule } from '@ngx-formly/core';
import { ngfModule } from 'angular-file';
import { AttachmentsModule } from 'libs/attachments/src/lib/attachments.module';
import { AuthorityModule } from 'libs/authorities/src/lib/authorities.module';
import { OrganisationAuthorityModule } from 'libs/authorities/src/lib/organisation-authority/organisation-authority.module';
import { BulkUploadsModule } from 'libs/bulk-uploads/src/lib/bulk-uploads.module';
import { DocumentationModule } from 'libs/documentation/src/lib/documentation.module';
import { FlightHistoryModule } from 'libs/flight-history/src/lib/flight-history.module';
import { JurisdictionsModule } from 'libs/jurisdictions/src/lib/jurisdictions.module';
import { LoadingIndicatorModule } from 'libs/loading-indicator/src/lib/loading-indicator.module';
import { RpaModule } from 'libs/rpa/src/lib/rpa.module';
import { WorkflowModule } from 'libs/workflows/src/lib/workflows.module';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { ModalModule } from 'ngx-bootstrap/modal';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { ToastrModule } from 'ngx-toastr';
import { PersonnelAddDialogue } from './add-dialogue/person-add-dialogue.component';
import { PersonnelAddToRegisterDialogueComponent } from './add-to-register-dialogue/personnel-add-to-register-dialogue.component';
import { PersonnelDialogue } from './details-dialogue/personnel-dialogue.component';
import { ManagingOrganisations } from './managing-organisations/managing-organisations.component';
import { PersonnelCurrencyComponent } from './personnel-currency/personnel-currency.component';
import { PersonnelDetailsComponent } from './personnel-details/personnel-details.component';
import { PersonnelDialoguesService } from './personnel-dialogues.service';
import { PersonnelEdit } from './personnel-edit/personnel-edit.component';
import { PersonnelRegisterStatusComponent } from './personnel-registers/personnel-registers-status.component';
import { PersonnelReportsDialogue } from './personnel-reports-dialogue/personnel-reports-dialogue.component';
import { PersonnelRoles } from './personnel-roles/personnel-roles.component';
import { PrintPersonnelReports } from './print-personnel-reports/print-personnel-reports.component';
@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        // ngx-bootstrap
        TooltipModule,
        ModalModule.forChild(),
        TabsModule,
        BsDropdownModule,
        BsDatepickerModule,
        PopoverModule,
        // ngx-formly
        ReactiveFormsModule,
        ValidationModule,
        FormlyModule,
        FormlyBootstrapModule,
        // ng-select
        NgSelectModule,
        ngfModule,
        ToastrModule,
        TooltipModule,
        SharedUiModule,
        DocumentationModule,
        WorkflowModule,
        AttachmentsModule,
        LoadingIndicatorModule,
        AuthorityModule,
        OrganisationAuthorityModule,
        RpaModule,
        FlightHistoryModule,
        JurisdictionsModule,
        BulkUploadsModule,
        EnhancedHelpModule,
        AnalyticsModule
    ],
    providers: [PersonnelDialoguesService],
    bootstrap: [],
    declarations: [
        PersonnelAddDialogue,
        PersonnelReportsDialogue,
        ManagingOrganisations,
        PersonnelDialogue,
        PersonnelDetailsComponent,
        PersonnelEdit,
        PersonnelRoles,
        PrintPersonnelReports,
        PersonnelRegisterStatusComponent,
        PersonnelCurrencyComponent,
        PersonnelAddToRegisterDialogueComponent
    ],
    exports: [
        ManagingOrganisations,
        PersonnelDialogue,
        PersonnelRoles,
        PrintPersonnelReports,
        PersonnelRegisterStatusComponent
    ]
})
export class PersonnelModule {}
